export default {
  todayAnchorClassName: 'js-today-entry-date'
}